import { render, staticRenderFns } from "./ComparativeColumnChart_TheS.vue?vue&type=template&id=248adf38&scoped=true&"
import script from "./ComparativeColumnChart_TheS.vue?vue&type=script&lang=js&"
export * from "./ComparativeColumnChart_TheS.vue?vue&type=script&lang=js&"
import style0 from "./ComparativeColumnChart_TheS.vue?vue&type=style&index=0&id=248adf38&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248adf38",
  null
  
)

export default component.exports